export const ROOT = '/';
export const PERSON_ROUTE = '/:id';
